module.exports = __webpack_public_path__ + "static/media/lanzamiento_xxlarge.33286aba.png";